<template>
  <div :style="isClipOrganizer || currentClip.clipNote ? '' : ''">
    <v-row align="center" justify="space-between" dense>
      <v-col cols="" class="container-clip-title text-truncate pl-4" style="width: auto">
        <!-- <v-tooltip top color="#131b1e"> -->
        <!-- <template v-slot:activator="{ on }"> -->
        <v-text-field
          ref="titleTxtF"
          :readonly="!isClipOrganizer"
          v-model="currentClip.clipTitle"
          :class="'tf-clip-' + (currentClip.clipTitle ? 'title' : 'untitled') + (isClipOrganizer ? '-organizer' : '')"
          :placeholder="isClipOrganizer ? $t('enterClipTitle') : 'Untitled'"
          hide-details
          flat
          solo
          @blur="saveTxtF"
          @keyup.enter="saveTxtF"
          dense
        ></v-text-field>
        <!-- </template>
          <span>
            {{ currentClip.clipTitle ? currentClip.clipTitle : isClipOrganizer ? $t('enterClipTitle') : 'Untitled' }}
          </span>
        </v-tooltip> -->
      </v-col>

      <!-- <v-spacer /> -->

      <v-col cols="auto" class="pr-4 container-clip-desc" v-if="currentClip.clipUploader">
        {{ calCreateAt(currentClip.clipUploadedAt) }}
      </v-col>
    </v-row>
    <v-row v-if="isClipOrganizer || currentClip.clipNote" no-gutters dense class="pl-3 mt-2">
      <v-col
        v-if="isClipOrganizer || currentClip.clipNote"
        cols=""
        class="note"
        :style="!isClipOrganizer && !currentClip.clipNote ? 'display: none; font-size: 14px' : 'font-size: 14px'"
      >
        <v-textarea
          v-if="isNoteEdit"
          ref="noteTxtF"
          class="textarea-note mr-3"
          :readonly="!isClipOrganizer"
          :disabled="!isClipOrganizer"
          no-resize
          v-model="currentClip.clipNote"
          hide-details
          flat
          solo
        ></v-textarea>
        <pre v-if="!isNoteEdit" class="area-note">
          <span style="word-break: break-word; white-space: pre-line; overflow-wrap: break-word" v-html="currentClip.clipNote ? notefilter : isClipOrganizer ? notePlaceholder : ''"></span>
        </pre>
      </v-col>
      <v-col cols="auto" v-if="isClipOrganizer && !isNoteEdit">
        <v-menu v-model="noteMenu" class="" offset-y bottom left dark>
          <template v-slot:activator="{ attrs, on }">
            <v-btn dark plain class="menu-note" v-bind="attrs" v-on="on">
              <span class="material-icons-round" style="color: #ddd; font-size: 17px; font-weight: 400" translate="no">
                {{ noteMenu ? 'close' : 'more_horiz' }}
              </span>
            </v-btn>
          </template>
          <div class="container-menu-comment" style="background-color: #1d292f; overflow: hidden">
            <v-row align="center" justify="center" dense>
              <v-col cols="12">
                <v-btn dark block plain elevation="0" class="btn-receive" @click="changeNoteEdit">
                  <span class="material-icons-round mr-1" style="color: #ddd; font-size: 18px; font-weight: 400">
                    edit_note
                  </span>
                  {{ 'Edit Note' }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-menu>
      </v-col>
    </v-row>
    <v-row dense class="" style="position: relative; width: 100%" align="center" v-if="isClipOrganizer">
      <v-col v-if="isClipOrganizer && currentClip.clipNote">
        <v-btn
          v-show="isClipOrganizer && !isNoteEdit && !isNoteExpand && currentClip.clipNote"
          class="btn-show"
          @click="showMore"
          elevation="0"
          plain
        >
          {{ 'Show more' }}
        </v-btn>
        <v-btn
          v-show="isClipOrganizer && !isNoteEdit && isNoteExpand && currentClip.clipNote"
          class="btn-show"
          @click="showLess"
          elevation="0"
          plain
        >
          {{ 'Show less' }}
        </v-btn>
      </v-col>
      <v-col v-if="isClipOrganizer && isNoteEdit" align="end" class="mt-1">
        <v-tooltip top left color="#131b1e">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="btn-note" @click=";(isNoteEdit = false), (noteMenu = false)" elevation="0" plain>
              <span class="material-icons-round mr-1" style="color: #ddd; font-size: 18px; font-weight: 400">
                cancel
              </span>
              {{ 'Cancel' }}
            </v-btn>
          </template>
          <span>
            {{ 'Cancel' }}
          </span>
        </v-tooltip>
        <v-tooltip top left color="#131b1e">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="btn-note ml-3"
              @click="saveTxtF(currentClip.clipNote), (noteMenu = false)"
              elevation="0"
              plain
            >
              <span class="material-icons-round mr-1" style="color: #ddd; font-size: 18px; font-weight: 400">task</span>
              {{ 'Post' }}
            </v-btn>
          </template>
          <span>
            {{ 'Post Note' }}
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <watched-user-dialog
      v-if="watchedUserVisible"
      @close="watchedUserVisible = false"
      :watchedUser.sync="currentClip.watchedUser"
      :anonymousUser.sync="currentClip.anonymousUser"
      :watchedUserVisible.sync="watchedUserVisible"
    ></watched-user-dialog>
  </div>
</template>

<script>
import { getFileDownload } from '@/services/api'
import { setClipUpdate } from '@/services/clipApi'
import watchedUserDialog from '@/views/modal/WatchedUserDialog'
// import ClipDeleteDialog from '@/views/modal/ClipDeleteDialog.vue'
import { mapState } from 'vuex'
import Toast from '@/views/meeting/component/Toast'
// import { download } from '@/services/api'

export default {
  name: 'DetailNote',
  components: {
    watchedUserDialog,
    // ClipDeleteDialog,
  },
  props: ['sectionIndex', 'sectionClipIndex'],
  data() {
    return {
      notePlaceholder: 'Add note',
      clipNote: '',
      clipTitle: '',
      watchedUserVisible: false,
      isIncludeShare: location.pathname.includes('share'),
      isDownloadLoading: false,
      noteRules: [
        // v => ( v && v.length >= 10 ) || "This field must have atleast 10 characters",
        // v => ( v && v.length <= 100 ) || "This field exceeds maximum allowed characters",
      ],
      isNoteEdit: false,
      isNoteExpand: false,
      noteMenu: false,
    }
  },
  created() {},
  mounted() {},
  methods: {
    changeNoteEdit() {
      this.isNoteEdit = true
      this.$nextTick(() => this.$refs.noteTxtF.focus())
    },
    showMore() {
      const noteArea = document.querySelector('.area-note')
      const note = document.querySelector('.note')
      note.style.maxHeight = 'none'
      noteArea.style.maxHeight = 'none'
      noteArea.style.height = 'auto'
      this.isNoteExpand = true
    },
    showLess() {
      const noteArea = document.querySelector('.area-note')
      // const note = document.querySelector('.note')
      noteArea.style.maxHeight = '60px'
      this.isNoteExpand = false
    },
    /**
     * Update Meeting Info
     * oldClip !== undefiend 인 경우는 자동으로 다음클립 넘어갔을 경우 재생시켜줄 때
     */
    async setClipUpdate() {
      if (this.editingClip !== undefined && this.editingClip !== null && this.isClipOrganizer) {
        // Blur 등 현재 상태에서 업데이트인 경우
        // if (this.editingClip.clipNote !== this.clipNote || this.editingClip.clipTitle === this.clipTitle) {
        let clipIndex = this.totalSectionList[this.sectionIndex].clipList.findIndex(
          (clip) => clip.clipId === this.editingClip.clipId
        )
        if (clipIndex >= 0) {
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipNote = this.editingClip.clipNote
          this.totalSectionList[this.sectionIndex].clipList[clipIndex].clipTitle = this.editingClip.clipTitle
          try {
            await setClipUpdate(
              this,
              this.$store.getters.selectedWsInfo.wsId,
              this.mtInfo.mtId,
              this.editingClip.clipId,
              this.editingClip.clipNote,
              this.editingClip.clipTitle
            )
          } catch (error) {
            console.log(error)
          } finally {
            // await this.$store.dispatch('setIsLoading', false)
          }
        }
        // }
      }
    },
    calCreateAt(val) {
      // return this.$day.duration(this.$day().diff(val)).humanize() + ' ago '
      let value
      try {
        value = this.$day(val).format('MMM D, h:mmA')
      } catch (err) {
        console.log(err)
      }

      return value
    },
    onWatchedUser() {
      if (this.totalWatchedUser.length > 0 && !this.isIncludeShare) this.watchedUserVisible = true
    },
    async downloadClip() {
      try {
        this.isDownloadLoading = true
        let title =
          this.currentClip.clipTitle !== undefined &&
          this.currentClip.clipTitle !== null &&
          this.currentClip.clipTitle !== ''
            ? this.currentClip.clipTitle
            : 'unTitled'

        // let result = await getFileDownload(this, this.mtInfo.wsId, this.currentClip.clipId, this.currentClip.isCopied)
        let result = await getFileDownload(this, this.mtInfo.wsId, this.currentClip.clipId)

        if (result !== undefined && result !== null) {
          let link = document.createElement('a')
          let url = URL.createObjectURL(result)
          link.href = url
          link.download = `${title}.mp4`
          link.click()
          setTimeout(function () {
            // document.body.removeChild(link)
            URL.revokeObjectURL(url)
          }, 100)
        } else {
          // notify(this, 'Error', this.$t('general.error'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } catch (err) {
        console.log('err   ', err)
        // notify(this, 'Error', this.$t('general.error'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isDownloadLoading = false
      }
    },
    // 현재 수정중인 Clip 을 Store Data 에 저장한다
    focusTxtF() {
      this.$store.dispatch('setEditingClip', this.currentClip)
    },
    // 현재 수정중인 Clip 을 Store Data 에 저장한다
    blurTxtF() {
      this.setClipUpdate()
      this.$store.dispatch('setEditingClip', null)
    },
    saveTxtF() {
      this.$store.dispatch('setEditingClip', this.currentClip)
      this.setClipUpdate()
      this.isNoteEdit = false
    },
    autoUpdate() {
      if (this.$refs.titleTxtF !== undefined) this.$refs.titleTxtF.blur()
      if (this.$refs.noteTxtF !== undefined) this.$refs.noteTxtF.blur()
    },
    setLinks(text) {
      const Rexp =
        /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\\/=~_|!:,.;]*)[-A-Z0-9+&@#\\/%=~_|])/gi
      return text.replaceAll('\n', '</br>').replace(Rexp, "<a href='$1' target='_blank'>$1</a>")
    },
  },
  computed: {
    notefilter() {
      let filteredNote
      const Rexp =
        /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\\/=~_|!:,.;]*)[-A-Z0-9+&@#\\/%=~_|])/gi

      if (this.currentClip.clipNote.includes('http')) {
        filteredNote = this.currentClip.clipNote
          .replace(Rexp, "<a href='$1' target='_blank'>$1</a>")
          .replace(/<(?!\/?br|a|\/a( |>))/g, '&lt;')
          .replace(/(?=&lt;[^>]+)>/g, '&gt;')
      } else {
        filteredNote = this.currentClip.clipNote
          .replace(/<(?!\/?br|a|\/a( |>))/g, '&lt;')
          .replace(/(?=&lt;[^>]+)>/g, '&gt;')
      }
      return filteredNote
    },
    totalWatchedUser() {
      let userList = []
      if (this.currentClip) {
        if (this.currentClip.watchedUser && this.currentClip.watchedUser.length > 0) {
          userList = userList.concat(this.currentClip.watchedUser)
        }
        if (this.currentClip.anonymousUser && this.currentClip.anonymousUser.length > 0) {
          userList = userList.concat(this.currentClip.anonymousUser)
        }
      }
      return userList
    },
    currentClip() {
      let currentClip
      try {
        currentClip = this.totalSectionList[this.sectionIndex].clipList[this.sectionClipIndex]
      } catch (e) {
        console.log()
      }
      // return state.clip.currentClip && state.clip.currentClip !== null ? state.clip.currentClip : {}
      return currentClip !== undefined && currentClip !== null ? currentClip : {}
    },
    ...mapState({
      mtInfo: (state) => {
        return state.auth.currentMt
      },
      userInfo: (state) => {
        return state.auth.userInfo && state.auth.userInfo !== null ? state.auth.userInfo : {}
      },
      wsInfo: (state) => {
        return state.auth.selectedWsInfo
      },
      storeSectionIndex: (state) => {
        return state.clip.sectionIndex
      },
      totalSectionList: (state) => {
        return state.clip.totalSectionList
      },
      clipIndex: (state) => {
        return state.clip.clipIndex
      },
      storeClipIndex: (state) => {
        return state.clip.clipIndex
      },
      editingClip: (state) => {
        return state.clip.editingClip
      },
    }),
    isClipOrganizer() {
      let clipUploader =
        this.currentClip !== undefined && this.currentClip !== null ? this.currentClip.clipUploader : null
      if (clipUploader && clipUploader !== null && this.userInfo && this.userInfo !== null)
        return clipUploader.userId === this.userInfo.userId
      else return false
    },
    isShowClipDelete() {
      return (
        this.userInfo &&
        this.userInfo !== null &&
        this.mtInfo &&
        this.mtInfo !== null &&
        (this.userInfo.userId === this.mtInfo.mtOrganizerUid ||
          (this.currentClip.clipUploader != undefined && this.userInfo.userId === this.currentClip.clipUploader.userId))
      )
    },
    getLink() {
      return this.setLinks(this.currentClip.clipNote)
    },
    isLastClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.isLastClip &&
        this.$store.getters.isLastClip !== null
      )
    },
  },
  watch: {
    currentClip() {
      this.autoUpdate()
      this.isNoteEdit = false
      this.noteMenu = false
    },
    sectionIndex() {
      this.autoUpdate()
    },
  },
}
</script>

<style scoped>
.container-note {
  position: relative;
  width: 100%;
  z-index: 2;
  /* margin-bottom: 5px; */
}
.container-note >>> .v-input {
  padding-top: 0px;
  margin-top: 0px;
}
.container-clip-title >>> .v-input__slot {
  background: transparent !important;
}
.container-clip-title >>> .v-input__slot input {
  color: white !important;
  text-overflow: ellipsis;
}
.container-clip-title {
  display: inline-block;
  position: relative;
}
.container-clip-desc {
  /* max-width: 40%; */
  /* flex: 0 0 40%; */
  min-width: 150px;
  text-align: right;
  font-size: 12px;
  color: #96a7af;
}
@media (max-width: 1263px) {
  .container-clip-title {
    max-width: calc(100% - 160px);
    flex: 0 0 100%;
  }
  .container-clip-desc {
    max-width: 130px;
    flex: 0 0 100%;
    padding: 0 5px 0 10px !important;
    text-align: right;
  }
}
.tf-clip-title,
.tf-clip-untitled,
.tf-clip-title-organizer,
.tf-clip-untitled-organizer {
  font-size: 18px;
  font-weight: 500;
  /* max-height: 40px; */
}
.container-clip-title >>> .tf-clip-title input::placeholder,
.container-clip-title >>> .tf-clip-untitled input::placeholder,
.container-clip-title >>> .tf-clip-title-organizer input::placeholder,
.container-clip-title >>> .tf-clip-untitled-organizer input::placeholder {
  color: white !important;
  opacity: 1;
  font-size: 16px !important;
  padding-top: 0;
  padding-bottom: 0;
}
.container-clip-title >>> .tf-clip-untitled input::placeholder,
.container-clip-title >>> .tf-clip-untitled-organizer input::placeholder {
  opacity: 0.5;
}
.container-clip-title >>> .tf-clip-title input,
.container-clip-title >>> .tf-clip-untitled input,
.container-clip-title >>> .tf-clip-title-organizer input,
.container-clip-title >>> .tf-clip-untitled-organizer input {
  color: white !important;
  opacity: 1;
  font-size: 16px !important;
  padding-top: 0;
  padding-bottom: 0;
}
.container-clip-title >>> .tf-clip-title .v-input__slot,
.container-clip-title >>> .tf-clip-untitled .v-input__slot,
.container-clip-title >>> .tf-clip-title-organizer .v-input__slot,
.container-clip-title >>> .tf-clip-untitled-organizer .v-input__slot {
  padding: 0 !important;
  /* min-width: 133%; */
  cursor: default;
}
.container-clip-title >>> .tf-clip-title input,
.container-clip-title >>> .tf-clip-untitled input {
  cursor: default;
}
.container-clip-title >>> .tf-clip-title-organizer input,
.container-clip-title >>> .tf-clip-untitled-organizer input {
  cursor: text;
}
.textarea-note {
  background-color: #30444e;
  line-break: anywhere;
  display: block;
  border-radius: 10px;
  color: #96a7af;
  font-size: 14px;
  overflow: hidden;
}
.textarea-note >>> .v-input__slot {
  padding-left: 0 !important;
}
.textarea-note >>> textarea {
  background-color: rgb(44, 64, 74);
  padding: 10px !important;
  margin: 0 !important;
  border-radius: 10px;
  border: 1px solid #63737d;
  color: rgb(210, 211, 224);
}
.note {
  padding: 0;
}
.area-note {
  color: #96a7af;
  text-indent: -30px;
  overflow: hidden;
  max-height: 60px;
}
.btn-note {
  bottom: 5px;
  right: 5px;
  background-color: transparent;
  color: #96a7af;
  z-index: 8;
  height: 36px;
  padding: 0px !important;
}
.btn-show {
  padding: 0 10px !important;
  color: #ddd;
}
.btn-show >>> span,
.btn-note >>> span {
  font-size: 13px;
  font-weight: 500;
}
@media (max-width: 1263px) {
  .note,
  .area-note,
  .textarea-note >>> textarea {
    max-height: 50px;
  }
  .btn-note {
    bottom: 5px;
    right: 0px;
    min-width: 0 !important;
    height: 25px;
  }
}

@media (max-width: 959px) {
  .container-clip-title >>> .tf-clip-title input,
  .container-clip-title >>> .tf-clip-untitled input,
  .container-clip-title >>> .tf-clip-title-organizer input,
  .container-clip-title >>> .tf-clip-untitled-organizer input {
    font-size: 14px !important;
    font-weight: 500;
  }
}

.container-menu-comment {
  width: 126px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.container-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
.container-btn .btn-control {
  width: 35px;
  height: 35px;
  background-color: transparent;
  padding: 0 !important;
  min-width: 35px !important;
}
.container-menu-comment >>> button {
  background-color: transparent !important;
}
.container-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-comment >>> .btn-control {
  width: 192px;
  justify-content: start;
}
.container-menu-comment >>> button:hover {
  /* border: 1px solid #666; */
  background-color: #161d21 !important;
}
.menu-note {
  min-width: 36px !important;
  padding: 0px !important;
}
</style>
